module.exports = __webpack_public_path__ + "media/post-registration/explore@1x-7f6061fb.png";